function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
export default {
  computed: {
    filteredValueColumns: function filteredValueColumns() {
      var flatColumns = this.flatColumns; // 只支持最下层的列,及没有下级且有filterValue的列

      return flatColumns.filter(function (v) {
        return !v.children && 'filteredValue' in v;
      });
    }
  },
  methods: {
    setFilters: function setFilters(filters) {
      this.innerFilters = filters;
    },
    initFilters: function initFilters() {
      var filteredValueColumns = this.filteredValueColumns,
          innerFilters = this.innerFilters,
          setFilters = this.setFilters;
      var nFilters = filteredValueColumns.reduce(function (r, v) {
        var nr = r;
        var val = v.filteredValue;

        if (val) {
          nr[v.$$_key] = Array.isArray(val) ? val : [val];
        } else {
          nr[v.$$_key] = null;
        }

        return nr;
      }, _objectSpread({}, innerFilters));
      setFilters(nFilters);
    },
    onFilterDropdownConfirm: function onFilterDropdownConfirm(column, selectedKeys) {
      var pagination = this.pagination,
          hasPagination = this.hasPagination,
          innerFilters = this.innerFilters,
          innerPager = this.innerPager,
          setFilters = this.setFilters,
          onPagerOrFiterOrSortChange = this.onPagerOrFiterOrSortChange;

      var nFilters = _objectSpread({}, innerFilters, _defineProperty({}, column.$$_key, selectedKeys));

      if (hasPagination) {
        // 重置当前页码
        innerPager.current = 1;

        if (isFunction(pagination.onChange)) {
          pagination.onChange(innerPager.current, innerPager.pageSize);
        }
      }

      setFilters(nFilters);
      onPagerOrFiterOrSortChange();
    }
  }
};